<template>
  <div>
    <div class="panel">
      <div class="dialog-group-title">选择打印模板</div>
      <el-form label-width="80px">
        <el-row>
          <el-col :span="24">
              <el-form-item label="模板名称" prop="orderCode">
                <el-select
                    size="small"
                      v-model="printTemplate"
                      clearable
                      placeholder="请选择"
                      style="width:100%;"

                      @change="templateChange"
                      v-if="editRow != null"

                  >
                      <el-option
                      v-for="item in printTemplateList"
                      :key="item._id"
                      :label="item.name"
                      :value="item._id"
                      >
                      <span style="float: left">{{ item.name }}</span>
                      <span style="float: right; color: red; font-size: 14px">

                        <i  class="el-icon-close" @click="delTemplate(item)"></i>
                      </span>
                    </el-option>
                  </el-select>
                  <el-input v-if="editRow == null" v-model="templateName" placeholder="输入模板名称"></el-input>

              </el-form-item>
            </el-col>


          </el-row>
        </el-form>

        <div class="dialog-group-title">预览</div>

        <el-table :data="channelForm.selectedChannelList" style="width: 100%" max-height="400">
            <el-table-column type="index" label="序号">
            </el-table-column>
            <el-table-column prop="name" label="字段名称">
            </el-table-column>
            <el-table-column
            label="操作"
            fixed="right">
            <template slot-scope ="scope">
              <el-button @click.native.prevent="activeRow(scope.$index, scope.row)" type="text" style="color:red;" size="small" v-if="scope.row.isActive">
                禁用
              </el-button>
              <el-button @click.native.prevent="activeRow(scope.$index, scope.row)" type="text" style="color:green;" size="small" v-if="!scope.row.isActive">
                启用
              </el-button>
              <!-- <el-button @click.native.prevent="deleteRow(scope.$index, scope.row, 'up')" type="text" size="small"> 上移</el-button>
              <el-button @click.native.prevent="deleteRow(scope.$index, scope.row, 'down')" type="text" size="small">下移</el-button> -->
            </template>
            </el-table-column>
        </el-table>






    </div>
    <div class="panel-bottom">
         <el-button size="small" type="default"  @click="closeDialog">关闭</el-button>
         <el-button size="small" type="primary" @click="save" >保存</el-button>
     </div>
  </div>
  </template>
  <script>

import moment from 'moment';
 import { queryPrintTemplateAll,printPreview,savePrintTemplate,delPrintTemplate} from '@/api/business';


  export default {
   name:'PrintTemplate',

   props:{
       userData:{
         type:Object,
         default:{},
       },

       editRow:{
           type:Object,

           default:{}
       },
       userList:{
          type:Array,

          default:[]
       },
       type:{
        type:String,
        default:''
       }

   },
   watch:{


       editRow:{
          handler(newVal) {

              if(newVal != null){
                  this.form = JSON.parse(JSON.stringify(newVal));
              }
          },
          deep: true,
          immediate: true
        },
        type:{
          handler(newVal) {

              if(newVal == 'enter'){
                this.channelForm = JSON.parse(JSON.stringify(this.reportForm));
              }
          },
          deep: true,
          immediate: true
        }
   },
   data(){
       return{
        printTemplateList:[],
        printTemplate:'',
        form:{},
        channelForm:{
          selectedChannelList:[

            {
              name:'工单编号',
              key:'orderCode',
              isActive:false
            },
            {
              name:'产品编号',
              key:'productCode',
              isActive:false
            },
            {
              name:'产品名称',
              key:'productName',
              isActive:false
            },
            {
              name:'工序编号',
              key:'processCode',
              isActive:false
            },
            {
              name:'工序名称',
              key:'processName',
              isActive:false
            },
            {
              name:'产品规格',
              key:'specs',
              isActive:false
            },
            {
              name:'报工权限',
              key:'userNameList',
              isActive:false
            },
            {
              name:'分配列表',
              key:'allocateList',
              isActive:false
            },
            {
              name:'报工数配比',
              key:'coefficient',
              isActive:false
            },
            {
              name:'计划数',
              key:'planNum',
              isActive:false
            },
            {
              name:'良品数',
              key:'goodNum',
              isActive:false
            },

            {
              name:'不良品数',
              key:'nongoodNum',
              isActive:false
            },
            {
              name:'任务状态',
              key:'taskStatus',
              isActive:false
            },
            {
              name:'计划开始时间',
              key:'planStartTime',
              isActive:false
            },
            {
              name:'计划结束时间',
              key:'planEndTime',
              isActive:false
            },
            {
              name:'实际开始时间',
              key:'actualStartTime',
              isActive:false
            },
            {
              name:'实际结束时间',
              key:'actualEndTime',
              isActive:false
            },
            {
              name:'创建人',
              key:'creater',
              isActive:false
            },
            {
              name:'创建时间',
              key:'createTime',
              isActive:false
            },
            {
              name:'更新时间',
              key:'updateTime',
              isActive:false
            },
          ],
          staticList:[
          {
              name:'工单编号',
              key:'orderCode',
              isActive:false
            },
            {
              name:'产品编号',
              key:'productCode',
              isActive:false
            },
            {
              name:'产品名称',
              key:'productName',
              isActive:false
            },
            {
              name:'工序编号',
              key:'processCode',
              isActive:false
            },
            {
              name:'工序名称',
              key:'processName',
              isActive:false
            },
            {
              name:'产品规格',
              key:'specs',
              isActive:false
            },
            {
              name:'报工权限',
              key:'userNameList',
              isActive:false
            },
            {
              name:'分配列表',
              key:'allocateList',
              isActive:false
            },
            {
              name:'报工数配比',
              key:'coefficient',
              isActive:false
            },
            {
              name:'计划数',
              key:'planNum',
              isActive:false
            },
            {
              name:'良品数',
              key:'goodNum',
              isActive:false
            },

            {
              name:'不良品数',
              key:'nongoodNum',
              isActive:false
            },
            {
              name:'任务状态',
              key:'taskStatus',
              isActive:false
            },
            {
              name:'计划开始时间',
              key:'planStartTime',
              isActive:false
            },
            {
              name:'计划结束时间',
              key:'planEndTime',
              isActive:false
            },
            {
              name:'实际开始时间',
              key:'actualStartTime',
              isActive:false
            },
            {
              name:'实际结束时间',
              key:'actualEndTime',
              isActive:false
            },
            {
              name:'创建人',
              key:'creater',
              isActive:false
            },
            {
              name:'创建时间',
              key:'createTime',
              isActive:false
            },
            {
              name:'更新时间',
              key:'updateTime',
              isActive:false
            },
          ],
          selectedChannelListindex:[],
        },
        reportForm:{
          selectedChannelList:[

            {
              name:'工单编号',
              key:'baseInfo.orderCode',
              isActive:false
            },
            {
              name:'产品编号',
              key:'baseInfo.productCode',
              isActive:false
            },
            {
              name:'产品名称',
              key:'baseInfo.productName',
              isActive:false
            },
            {
              name:'工序编号',
              key:'baseInfo.processCode',
              isActive:false
            },
            {
              name:'工序名称',
              key:'baseInfo.processName',
              isActive:false
            },
            {
              name:'产品规格',
              key:'baseInfo.specs',
              isActive:false
            },
            {
              name:'报工数量',
              key:'baseInfo.countNum',
              isActive:false
            },
            {
              name:'计价方式',
              key:'performanceInfo.countType',
              isActive:false
            },
            {
              name:'工资单价',
              key:'performanceInfo.salaryUnit',
              isActive:false
            },
            {
              name:'预计工资',
              key:'performanceInfo.estimateSalary',
              isActive:false
            },
            {
              name:'良品数',
              key:'baseInfo.goodNum',
              isActive:false
            },

            {
              name:'不良品数',
              key:'baseInfo.nongoodNum',
              isActive:false
            },
            {
              name:'单位',
              key:'baseInfo.unit',
              isActive:false
            },
            {
              name:'生产人员',
              key:'baseInfo.producer.name',
              isActive:false
            },
            {
              name:'报工时间',
              key:'baseInfo.timeRange',
              isActive:false
            },
            {
              name:'创建人',
              key:'creater',
              isActive:false
            },
            {
              name:'创建时间',
              key:'createTime',
              isActive:false
            },
            {
              name:'更新人',
              key:'updator',
              isActive:false
            },
            {
              name:'更新时间',
              key:'updateTime',
              isActive:false
            },
          ],
          staticList:[

            {
              name:'工单编号',
              key:'baseInfo.orderCode',
              isActive:false
            },
            {
              name:'产品编号',
              key:'baseInfo.productCode',
              isActive:false
            },
            {
              name:'产品名称',
              key:'baseInfo.productName',
              isActive:false
            },
            {
              name:'工序编号',
              key:'baseInfo.processCode',
              isActive:false
            },
            {
              name:'工序名称',
              key:'baseInfo.processName',
              isActive:false
            },
            {
              name:'产品规格',
              key:'baseInfo.specs',
              isActive:false
            },
            {
              name:'报工数量',
              key:'baseInfo.countNum',
              isActive:false
            },
            {
              name:'计价方式',
              key:'performanceInfo.countType',
              isActive:false
            },
            {
              name:'工资单价',
              key:'performanceInfo.salaryUnit',
              isActive:false
            },
            {
              name:'预计工资',
              key:'performanceInfo.estimateSalary',
              isActive:false
            },
            {
              name:'良品数',
              key:'baseInfo.goodNum',
              isActive:false
            },

            {
              name:'不良品数',
              key:'baseInfo.nongoodNum',
              isActive:false
            },
            {
              name:'单位',
              key:'baseInfo.unit',
              isActive:false
            },
            {
              name:'生产人员',
              key:'baseInfo.producer.name',
              isActive:false
            },
            {
              name:'报工时间',
              key:'baseInfo.timeRange',
              isActive:false
            },
            {
              name:'创建人',
              key:'creater',
              isActive:false
            },
            {
              name:'创建时间',
              key:'createTime',
              isActive:false
            },
            {
              name:'更新人',
              key:'updator',
              isActive:false
            },
            {
              name:'更新时间',
              key:'updateTime',
              isActive:false
            },
            ],
          selectedChannelListindex:[],
        },
        imgBase64:'',
        printData:[],
        templateName:"",

       }
   },
   created(){
    if(this.userData && this.editRow != null){
      this.init();

    }
   },
   methods:{
    activeRow(index,row){
      this.$set(this.channelForm.selectedChannelList[index],'isActive',!row.isActive);
      this.channelForm.selectedChannelList.sort((a,b)=>{

        if(!a.isActive){
          return 1;

        }
        if(!b.isActive){
          return -1;
        }
        return 0;
      })
    },
    templateChange(val){
      let data = this.printTemplateList.filter(item=>item._id == val)[0];
      this.channelForm.selectedChannelList = JSON.parse(JSON.stringify(this.channelForm.staticList));
      for(let i = 0;i<data.content.length;i++){
        for(let j = 0;j<this.channelForm.selectedChannelList.length;j++){
          if(this.channelForm.selectedChannelList[j].key == data.content[i]){
            this.$set(this.channelForm.selectedChannelList[j],'isActive',true);

            break;
          }
        }
      }

      this.channelForm.selectedChannelList.sort((a,b)=>{

        if(!a.isActive){
          return 1;

        }
        if(!b.isActive){
          return -1;
        }
        return 0;
      })
    },
    init(){
      this.printTemplateList = [];
      queryPrintTemplateAll(this.userData.factoryId,this.type).then(res=>{
        if(res.code == 200 && res['data'].length > 0){
          this.printTemplateList = res['data'];
          this.printTemplate = res['data'][0]._id;
          this.templateChange(this.printTemplate);
        }
      });
    },
    deleteRow (index, e, type) {
        if (type === 'up') {
          if (index === 0){

            return;
          }
          //在上一项插入该项
          this.channelForm.selectedChannelList.splice(index - 1, 0, (this.channelForm.selectedChannelList[index]));// 删除后一项
          this.channelForm.selectedChannelList.splice(index + 1, 1);
        } else if (type === 'down') {
          if (index === (this.channelForm.selectedChannelList.length - 1)){

            return;
          }
          this.channelForm.selectedChannelList.splice(index + 2,0,(this.channelForm.selectedChannelList[index]));
          this.channelForm.selectedChannelList.splice(index,1);
        }
    },
    save(){
      let content =[];
      for(let i = 0;i<this.channelForm.selectedChannelList.length;i++){
        if(this.channelForm.selectedChannelList[i].isActive){
          content.push(this.channelForm.selectedChannelList[i].key);
        }
      }
      let template = {};
      if(this.editRow != null){

        template = JSON.parse(JSON.stringify(this.printTemplateList.filter(item=>item._id == this.printTemplate)[0]));
        template.content = content;
        template.name = (template.name ? template.name :('默认模板' + moment().format('YYYYMMDDHHmmss')));
      }else{
        if(this.templateName == null || this.templateName.length == 0){
          this.$message.warning('请输入模板名称');
          return;
        }
        template = {
          content:content,
          name:this.templateName,
          factoryId:this.userData.factoryId,
          type:this.type
        };
      }


      savePrintTemplate(template).then(res=>{
        if(res.code == 200){
          this.$message.success('保存成功')
          this.$emit('done',{type:'save'})
        }else{
          this.$message.error(res.msg)
        }
      })
    },

    closeDialog(){
      this.$emit('done',{type:'cancel'})
    },
    delTemplate(item){
      this.$confirm('确认删除打印模板：' + item.name + '?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {

        delPrintTemplate(item._id).then(res=>{
          if (res.code == 200) {
            this.$message({
              type: 'success',
              message: '操作成功！'
            });
            this.init();
          } else {
            this.$message({
              type: 'error',
              message: res.msg
            })
          }
        })
      }).catch(() => {

      })
    }
   }

  }
  </script>
  <style>
   .panel{
       overflow-y: auto;
       overflow-x: hidden;
   }

   .panel-bottom{
       width: 100%;
       height: 40px;
       line-height: 40px;
       padding-top: 20px;
       text-align: center;
   }
   .panel-bottom el-button{
       margin: 10px 0 0 10px;
   }
   .printTbl {
        border-right: 1px solid #000000;
        border-bottom: 1px solid #000000;
        text-align: center;
    }

    .printTbl th {
        border-left: 1px solid #000000;
        border-top: 1px solid #000000;
    }

    .printTbl td {
        border-left: 1px solid #000000;
        border-top: 1px solid #000000;
    }
  </style>



// WEBPACK FOOTER //
// src/views/task/PrintTemplate.vue